module.exports = __webpack_public_path__ + "img/yanglaoyizhagntu.8e8e08b0.png";